export enum FetchMoreInfiniteButtonHelperPlacement {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM'
}
